import React, { useState, useEffect } from 'react';
import {
    Box,
    Grid,
    Typography,
    Button,
    Paper,
    Tabs,
    Tab,
    Alert,
    CircularProgress,
    Fab,
    IconButton,
    Chip,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Divider,
    Card,
    CardContent,
    LinearProgress,
    Tooltip,
    Menu,
    List,
    ListItem,
    MenuList,
    MenuItem as MenuItemComponent,
    ListItemIcon,
    ListItemText,
    Avatar
} from '@mui/material';
import {
    Dashboard as DashboardIcon,
    Refresh as RefreshIcon,
    LocalShipping as LocalShippingIcon,
    Timeline as TimelineIcon,
    Paid as PaidIcon,
    CheckCircle as CheckCircleIcon,
    Assessment as AssessmentIcon,
    DirectionsCar as DirectionsCarIcon,
    Notifications as NotificationsIcon,
    Warning as WarningIcon,
    Security as SecurityIcon,
    Analytics as AnalyticsIcon,
    CompareArrows as CompareArrowsIcon,
    Map as MapIcon,
    LocalGasStation as LocalGasStationIcon,
    Route as RouteIcon,
    Speed as SpeedIcon,
    Person as PersonIcon,
    Business as BusinessIcon,
    Add as AddIcon,
    Visibility as VisibilityIcon,
    Edit as EditIcon,
    Cancel as CancelIcon,
    Build as BuildIcon,
    Receipt as ReceiptIcon,
    Description as DescriptionIcon,
    Assignment as AssignmentIcon,
    AddCircleOutline as AddCircleOutlineIcon,
    MoreVert as MoreVertIcon,
    FilterList as FilterListIcon,
    Download as DownloadIcon,
    Upload as UploadIcon,
    Delete as DeleteIcon,
    Schedule as ScheduleIcon,
    LocationOn as LocationOnIcon,
    Event as EventIcon,
    AttachFile as AttachFileIcon,

} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PendingIcon from '@mui/icons-material/Pending';
import DoneAllIcon from '@mui/icons-material/DoneAll';

import {
    LineChart,
    Line,
    BarChart,
    Bar,
    PieChart,
    Pie,
    Cell,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    Legend,
    ResponsiveContainer,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Radar,
    Area,
    AreaChart
} from 'recharts';
import { useAuth } from '../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import tripService from '../API/tripService';
import documentService from '../API/documentService';
import maintenanceService from '../API/maintenanceService';
import dashboardService from '../API/dashboardService';
import dashboardService1 from '../API/dashboardServices';



import TokenExpired from '../Components/TokenExpired';

const COLORS = ['#6366f1', '#10b981', '#f59e0b', '#ec4899', '#8b5cf6', '#ef4444', '#14b8a6', '#f97316'];
// Table Component for Operations
const OperationsTable = ({ data, columns, title, icon, actions }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);

    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(row);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedRow(null);
    };

    return (
        <ChartCard
            title={title}
            icon={icon}
            action={
                <Button
                    variant="outlined"
                    startIcon={<FilterListIcon />}
                    size="small"
                    sx={{ borderRadius: 2, borderColor: '#e2e8f0', color: '#64748b' }}
                >
                    Filtrer
                </Button>
            }
        >
            <TableContainer sx={{ maxHeight: 400 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell
                                    key={column.id}
                                    align={column.align}
                                    style={{ minWidth: column.minWidth, fontWeight: 600, color: '#1e293b' }}
                                >
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell align="center" style={{ minWidth: 100, fontWeight: 600, color: '#1e293b' }}>
                                Actions
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data.map((row) => (
                            <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                                {columns.map((column) => {
                                    const value = row[column.id];
                                    return (
                                        <TableCell key={column.id} align={column.align}>
                                            {column.format ? column.format(value) : value}
                                        </TableCell>
                                    );
                                })}
                                <TableCell align="center">
                                    <IconButton
                                        aria-label="more"
                                        aria-controls="long-menu"
                                        aria-haspopup="true"
                                        onClick={(e) => handleMenuClick(e, row)}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                    <Menu
                                        id="long-menu"
                                        anchorEl={anchorEl}
                                        keepMounted
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                    >
                                        {actions.map((action) => (
                                            <MenuItem
                                                key={action.id}
                                                onClick={() => {
                                                    action.handler(selectedRow);
                                                    handleMenuClose();
                                                }}
                                            >
                                                <ListItemIcon>
                                                    {action.icon}
                                                </ListItemIcon>
                                                <ListItemText primary={action.label} />
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </ChartCard>
    );
};

const formatDuration = (durationInSeconds) => {
    if (typeof durationInSeconds !== 'number' || isNaN(durationInSeconds) || durationInSeconds < 0) {
        return 'N/A';
    }

    if (durationInSeconds === 0) {
        return '0s';
    }

    const timeUnits = {
        day: 86400,    // 60 * 60 * 24
        hour: 3600,    // 60 * 60
        minute: 60,    // 60
        second: 1,
    };

    let remainingSeconds = durationInSeconds;
    const parts = [];

    // Calculate days
    if (remainingSeconds >= timeUnits.day) {
        const days = Math.floor(remainingSeconds / timeUnits.day);
        parts.push(`${days}d`);
        remainingSeconds %= timeUnits.day;
    }

    // Calculate hours
    if (remainingSeconds >= timeUnits.hour) {
        const hours = Math.floor(remainingSeconds / timeUnits.hour);
        parts.push(`${hours}h`);
        remainingSeconds %= timeUnits.hour;
    }

    // Calculate minutes
    if (remainingSeconds >= timeUnits.minute) {
        const minutes = Math.floor(remainingSeconds / timeUnits.minute);
        parts.push(`${minutes}m`);
        remainingSeconds %= timeUnits.minute;
    }

    // Calculate seconds
    if (remainingSeconds > 0) {
        parts.push(`${Math.round(remainingSeconds)}s`);
    }

    return parts.join(' ');
};
const formatDistance = (distanceInMeters) => {
    if (typeof distanceInMeters !== 'number' || isNaN(distanceInMeters)) {
        return 'N/A';
    }

    if (distanceInMeters < 1000) {
        // Show meters for distances less than 1 km
        return `${Math.round(distanceInMeters)} m`;
    } else {
        // Show kilometers for distances 1 km or more
        const distanceInKm = distanceInMeters / 1000;
        return `${distanceInKm.toFixed(1)} km`;
    }
};
// Modern KPI Card Component
const KPICard = ({ title, value, icon, color, bgColor, trend, subtitle, onClick }) => (
    <Card
        sx={{
            p: 3,
            borderRadius: 3,
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
            border: '1px solid #e2e8f0',
            transition: 'all 0.3s ease',
            cursor: onClick ? 'pointer' : 'default',
            '&:hover': onClick ? {
                transform: 'translateY(-4px)',
                boxShadow: '0 8px 30px rgba(0,0,0,0.12)',
            } : {}
        }}
        onClick={onClick}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
            <Box sx={{
                p: 2,
                borderRadius: 2,
                background: bgColor,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                {icon}
            </Box>
            {trend !== undefined && (
                <Chip
                    label={`${trend > 0 ? '+' : ''}${trend}%`}
                    size="small"
                    icon={trend > 0 ? <TrendingUpIcon /> : <TrendingDownIcon />}
                    sx={{
                        bgcolor: trend > 0 ? '#10b981' : '#ef4444',
                        color: 'white',
                        fontWeight: 'bold'
                    }}
                />
            )}
        </Box>
        <Typography variant="h4" sx={{
            fontWeight: 700,
            color: '#1e293b',
            fontFamily: '"Montserrat", sans-serif',
            mb: 1
        }}>
            {value}
        </Typography>
        <Typography variant="h6" sx={{
            color: '#64748b',
            fontFamily: '"Montserrat", sans-serif',
            fontWeight: 500
        }}>
            {title}
        </Typography>
        {subtitle && (
            <Typography variant="body2" sx={{
                color: '#94a3b8',
                fontFamily: '"Montserrat", sans-serif',
                mt: 1
            }}>
                {subtitle}
            </Typography>
        )}
    </Card>
);

// Modern Chart Card Component
const ChartCard = ({ title, icon, children, subtitle, action }) => (
    <Card sx={{
        p: 3,
        borderRadius: 3,
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        border: '1px solid #e2e8f0',
        height: '100%'
    }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{
                    p: 1.5,
                    borderRadius: 2,
                    background: 'rgba(99, 102, 241, 0.1)',
                    mr: 2
                }}>
                    {icon}
                </Box>
                <Box>
                    <Typography variant="h6" sx={{
                        fontWeight: 600,
                        color: '#1e293b',
                        fontFamily: '"Montserrat", sans-serif'
                    }}>
                        {title}
                    </Typography>
                    {subtitle && (
                        <Typography variant="body2" sx={{
                            color: '#64748b',
                            fontFamily: '"Montserrat", sans-serif'
                        }}>
                            {subtitle}
                        </Typography>
                    )}
                </Box>
            </Box>
            {action}
        </Box>
        {children}
    </Card>
);

const TaskList = ({ tasks, title, icon }) => {
    const getTaskIcon = (type) => {
        switch (type) {
            case 'maintenance': return <BuildIcon color="warning" />;
            case 'document': return <DescriptionIcon color="info" />;
            case 'trip': return <LocalShippingIcon color="success" />;
            case 'payment': return <AttachMoneyIcon color="error" />;
            default: return <AssignmentIcon color="action" />;
        }
    };

    const getTaskStatus = (status) => {
        switch (status) {
            case 'pending': return <PendingIcon color="warning" />;
            case 'completed': return <DoneAllIcon color="success" />;
            case 'cancelled': return <CancelIcon color="error" />;
            default: return <PendingIcon color="action" />;
        }
    };

    return (
        <ChartCard title={title} icon={icon}>
            <List sx={{ width: '100%', maxHeight: 400, overflow: 'auto' }}>
                {tasks.map((task) => (
                    <ListItem key={task.id} sx={{ mb: 1, p: 2, borderRadius: 2, bgcolor: '#f8fafc' }}>
                        <ListItemIcon>
                            {getTaskIcon(task.type)}
                        </ListItemIcon>
                        <ListItemText
                            primary={task.title}
                            secondary={
                                <Box>
                                    <Typography variant="body2" color="text.secondary">
                                        {task.description}
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
                                        <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
                                            {task.dueDate}
                                        </Typography>
                                        {getTaskStatus(task.status)}
                                    </Box>
                                </Box>
                            }
                        />
                        <IconButton edge="end" aria-label="view">
                            <VisibilityIcon />
                        </IconButton>
                    </ListItem>
                ))}
            </List>
        </ChartCard>
    );
};
const formatCurrency = (value) => {
    return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'MAD',
        maximumFractionDigits: 0
    }).format(value);
};

// Format date
const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
};
const OperationDialog = ({ open, handleClose, title, children }) => {
    return (
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
            <DialogTitle sx={{ bgcolor: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: '#1e293b' }}>
                        {title}
                    </Typography>
                    <IconButton edge="end" onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
                {children}
            </DialogContent>
            <DialogActions sx={{ p: 3, borderTop: '1px solid #e2e8f0' }}>
                <Button onClick={handleClose} sx={{ borderRadius: 2 }}>
                    Annuler
                </Button>
                <Button variant="contained" onClick={handleClose} sx={{ borderRadius: 2, bgcolor: '#6366f1' }}>
                    Enregistrer
                </Button>
            </DialogActions>
        </Dialog>
    );
};
const ActivityFeed = ({ activities }) => {
    if (!activities || activities.length === 0) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 300 }}>
                <Typography sx={{ color: '#64748b', fontFamily: '"Montserrat", sans-serif' }}>
                    Aucune activité récente
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ maxHeight: 300, overflowY: 'auto' }}>
            {activities.map((activity, index) => (
                <Box key={index} sx={{
                    p: 2,
                    borderRadius: 2,
                    background: '#f8fafc',
                    mb: 2,
                    border: '1px solid #e2e8f0',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        background: '#f1f5f9',
                        transform: 'translateX(4px)'
                    }
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                        <Avatar sx={{ width: 32, height: 32, bgcolor: '#6366f1', mr: 2 }}>
                            <LocalShippingIcon sx={{ fontSize: 16 }} />
                        </Avatar>
                        <Typography variant="body1" sx={{
                            fontWeight: 500,
                            color: '#1e293b',
                            fontFamily: '"Montserrat", sans-serif'
                        }}>
                            {activity.title}
                        </Typography>
                    </Box>
                    <Typography variant="body2" sx={{
                        color: '#64748b',
                        fontFamily: '"Montserrat", sans-serif',
                        ml: 6
                    }}>
                        {activity.description}
                    </Typography>
                    <Typography variant="caption" sx={{
                        color: '#94a3b8',
                        fontFamily: '"Montserrat", sans-serif',
                        ml: 6
                    }}>
                        {activity.timestamp}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

// Alert Card Component
const AlertCard = ({ title, message, type, count, icon }) => {
    const colors = {
        warning: { bg: 'rgba(245, 158, 11, 0.1)', color: '#f59e0b', border: 'rgba(245, 158, 11, 0.3)' },
        error: { bg: 'rgba(239, 68, 68, 0.1)', color: '#ef4444', border: 'rgba(239, 68, 68, 0.3)' },
        info: { bg: 'rgba(59, 130, 246, 0.1)', color: '#3b82f6', border: 'rgba(59, 130, 246, 0.3)' }
    };

    const colorScheme = colors[type] || colors.info;

    return (
        <Card sx={{
            p: 3,
            borderRadius: 3,
            background: colorScheme.bg,
            border: `2px solid ${colorScheme.border}`,
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Box sx={{
                    p: 1.5,
                    borderRadius: 2,
                    background: colorScheme.color,
                    mr: 2
                }}>
                    {icon}
                </Box>
                <Box>
                    <Typography variant="h6" sx={{
                        fontWeight: 600,
                        color: colorScheme.color,
                        fontFamily: '"Montserrat", sans-serif'
                    }}>
                        {title}
                    </Typography>
                    <Typography variant="h4" sx={{
                        fontWeight: 700,
                        color: colorScheme.color,
                        fontFamily: '"Montserrat", sans-serif'
                    }}>
                        {count}
                    </Typography>
                </Box>
            </Box>
            <Typography variant="body2" sx={{
                color: '#64748b',
                fontFamily: '"Montserrat", sans-serif'
            }}>
                {message}
            </Typography>
        </Card>
    );
};


const Dashboard = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [token, setToken] = useState(null);
    const [role, setRole] = useState(null);
    const [dashboardData, setDashboardData] = useState({
        summary: {
            totalVoyages: 0,
            activeVoyages: 0,
            completedVoyages: 0,
            totalRevenue: 0,
            monthlyStats: {
                voyages: 0,
                revenue: 0
            }
        },
        monthlyRevenue: [],
        voyagesByType: [],
        topRoutes: [],
        vehicleStatus: [],
        fuelConsumption: [],
        clientDistribution: [],
        driverPerformance: [],
        upcomingMaintenance: [],
        revenueByRegion: [],
        recentActivities: [],
        alerts: [],
        analytics: {
            fillRate: 0,
            avgFuelConsumption: 0,
            avgDistance: 0,
            avgDuration: 0
        }
    });

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [newTripDialogOpen, setNewTripDialogOpen] = useState(false);
    const [maintenanceDialogOpen, setMaintenanceDialogOpen] = useState(false);
    const [documentDialogOpen, setDocumentDialogOpen] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [tripActionMenu, setTripActionMenu] = useState(null);
    const [dateRange, setDateRange] = useState('30');
    const [refreshInterval, setRefreshInterval] = useState(null);

    // Form states
    const [newTripForm, setNewTripForm] = useState({
        clientId: '',
        vehicleId: '',
        driverId: '',
        departureLocation: '',
        destinationLocation: '',
        departureDate: '',
        expectedArrivalDate: '',
        cargoType: '',
        cargoWeight: '',
        estimatedRevenue: '',
        notes: ''
    });

    const [maintenanceForm, setMaintenanceForm] = useState({
        vehicleId: '',
        maintenanceType: '',
        scheduledDate: '',
        estimatedCost: '',
        description: '',
        priority: 'medium'
    });

    const [documentForm, setDocumentForm] = useState({
        title: '',
        type: '',
        entityId: '',
        entityType: '',
        expirationDate: '',
        file: null
    });

    // Fetch dashboard data
    const fetchDashboardData = async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await dashboardService1.getStats();

            const apiData = response.data;

            // Monthly Revenue
            const monthlyRevenue = apiData.monthlyRevenue.months.map((month, index) => ({
                month,
                revenue: Number(apiData.monthlyRevenue.revenues[index] || 0)
            }));

            // Vehicle Status
            const vehicleStatus = apiData.vehicleStatus.labels.map((label, index) => ({
                name: label,
                value: Number(apiData.vehicleStatus.data[index])
            }));

            // Client Distribution
            const clientDistribution = apiData.clientDistribution.labels.map((label, index) => ({
                name: label,
                value: Number(apiData.clientDistribution.data[index])
            }));

            // Fuel Consumption
            const fuelConsumption = apiData.fuelConsumption.months.map((month, index) => ({
                month,
                consumption: Number(apiData.fuelConsumption.consumption[index] || 0),
                cost: 0
            }));

            // Revenue By Region
            const revenueByRegion = apiData.revenueByRegion.regions.map((region, index) => ({
                name: region,
                value: Number(apiData.revenueByRegion.revenues[index] || 0)
            }));

            // Top Routes
            const topRoutes = apiData.topRoutes.map(route => ({
                from: route.route.split("→")[0].trim(),
                to: route.route.split("→")[1]?.trim(),
                count: route.count,
                revenue: 0,
                avgDistance: 0,
                avgDuration: 0
            }));

            setDashboardData({
                summary: {
                    ...apiData.summary,
                    totalRevenue: Number(apiData.summary.totalRevenue),
                    monthlyStats: {
                        voyages: apiData.summary.monthlyStats.voyages,
                        revenue: Number(apiData.summary.monthlyStats.revenue)
                    }
                },

                monthlyRevenue,
                voyagesByType: [],
                topRoutes,
                vehicleStatus,
                fuelConsumption,
                clientDistribution,
                driverPerformance: apiData.driverPerformance || [],
                upcomingMaintenance: [],
                revenueByRegion,
                recentActivities: [],
                alerts: []
            });

        } catch (error) {
            console.error("Error fetching dashboard data:", error);
            setError(error.message || "Erreur chargement dashboard");
        } finally {
            setLoading(false);
        }
    };

    // Fetch active trips
    const fetchActiveTrips = async () => {
        try {
            const trips = await tripService.getActiveTrips();
            return trips;
        } catch (error) {
            console.error('Error fetching active trips:', error);
            return [];
        }
    };

    // Fetch upcoming tasks
    // const fetchUpcomingTasks = async () => {
    //     try {
    //         const tasks = await dashboardService1.getUpcomingTasks();
    //         return tasks;
    //     } catch (error) {
    //         console.error('Error fetching upcoming tasks:', error);
    //         return [];
    //     }
    // };

    // Create new trip
    const handleCreateTrip = async () => {
        try {
            await tripService.createTrip(newTripForm);
            setNewTripDialogOpen(false);
            setNewTripForm({
                clientId: '',
                vehicleId: '',
                driverId: '',
                departureLocation: '',
                destinationLocation: '',
                departureDate: '',
                expectedArrivalDate: '',
                cargoType: '',
                cargoWeight: '',
                estimatedRevenue: '',
                notes: ''
            });
            fetchDashboardData();
        } catch (error) {
            console.error('Error creating trip:', error);
            setError(error.message || 'Échec de la création du voyage');
        }
    };

    // Schedule maintenance
    const handleScheduleMaintenance = async () => {
        try {
            await maintenanceService.scheduleMaintenance(maintenanceForm);
            setMaintenanceDialogOpen(false);
            setMaintenanceForm({
                vehicleId: '',
                maintenanceType: '',
                scheduledDate: '',
                estimatedCost: '',
                description: '',
                priority: 'medium'
            });
            fetchDashboardData();
        } catch (error) {
            console.error('Error scheduling maintenance:', error);
            setError(error.message || 'Échec de la planification de la maintenance');
        }
    };

    // Upload document
    const handleUploadDocument = async () => {
        try {
            const formData = new FormData();
            Object.keys(documentForm).forEach(key => {
                if (key !== 'file') {
                    formData.append(key, documentForm[key]);
                }
            });
            if (documentForm.file) {
                formData.append('file', documentForm.file);
            }

            await documentService.uploadDocument(formData);
            setDocumentDialogOpen(false);
            setDocumentForm({
                title: '',
                type: '',
                entityId: '',
                entityType: '',
                expirationDate: '',
                file: null
            });
            fetchDashboardData();
        } catch (error) {
            console.error('Error uploading document:', error);
            setError(error.message || 'Échec du téléchargement du document');
        }
    };

    // Handle trip actions
    const handleTripAction = async (action, tripId) => {
        try {
            switch (action) {
                case 'view':
                    navigate(`/trips/${tripId}`);
                    break;
                case 'edit':
                    navigate(`/trips/${tripId}/edit`);
                    break;
                case 'cancel':
                    await tripService.cancelTrip(tripId);
                    fetchDashboardData();
                    break;
                case 'complete':
                    await tripService.completeTrip(tripId);
                    fetchDashboardData();
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.error(`Error ${action} trip:`, error);
            setError(error.message || `Échec de l'action: ${action}`);
        }
        setTripActionMenu(null);
    };

    // Handle tab change
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    // Refresh data
    const refreshData = () => {
        fetchDashboardData();
    };

    // Auto-refresh
    useEffect(() => {

        const interval = setInterval(() => {
            if (role === 'admin' || role === 'super-admin') {
                fetchDashboardData();
            }
        }, 60000); // Refresh every minute for admins

        setRefreshInterval(interval);
        return () => clearInterval(interval);
    }, [role]);

    // Initial data fetch
    useEffect(() => {
        const storedAuthState = sessionStorage.getItem("authLocalstorage");
        const parsedAuthState = JSON.parse(storedAuthState);
        setToken(parsedAuthState.token);
        setRole(parsedAuthState.user.role.name);
        if (token) {
            fetchDashboardData();
        }
    }, [token, dateRange]);

    // Check user role
    if (!token || !['user-facture', 'admin', 'super-admin'].includes(role)) {
        return <TokenExpired />;
    }

    // Trip columns for operations table
    const tripColumns = [
        { id: 'reference', label: 'Référence', minWidth: 100 },
        { id: 'client', label: 'Client', minWidth: 120 },
        { id: 'departure', label: 'Départ', minWidth: 120 },
        { id: 'destination', label: 'Destination', minWidth: 120 },
        {
            id: 'status', label: 'Statut', minWidth: 100, format: (value) => (
                <Chip
                    label={value}
                    size="small"
                    color={value === 'En cours' ? 'primary' : value === 'Terminé' ? 'success' : value === 'Annulé' ? 'error' : 'default'}
                />
            )
        },
        { id: 'driver', label: 'Chauffeur', minWidth: 120 },
        { id: 'vehicle', label: 'Véhicule', minWidth: 100 },
        { id: 'departureDate', label: 'Départ', minWidth: 120, format: (value) => formatDate(value) },
        {
            id: 'progress', label: 'Progression', minWidth: 120, format: (value) => (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                        <LinearProgress variant="determinate" value={value} />
                    </Box>
                    <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2">{`${Math.round(value)}%`}</Typography>
                    </Box>
                </Box>
            )
        }
    ];

    const tripActions = [
        { id: 'view', label: 'Voir les détails', icon: <VisibilityIcon fontSize="small" /> },
        { id: 'edit', label: 'Modifier', icon: <EditIcon fontSize="small" /> },
        { id: 'complete', label: 'Terminer', icon: <CheckCircleIcon fontSize="small" /> },
        { id: 'cancel', label: 'Annuler', icon: <CancelIcon fontSize="small" /> }
    ];

    return (
        <Box
            sx={{
                width: '100%',
                backgroundColor: '#f8fafc',
                minHeight: '100vh',
                fontFamily: '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                padding: { xs: 2, sm: 3, md: 4 }
            }}
        >
            {/* Header */}
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
                flexWrap: 'wrap',
                gap: 2
            }}>
                <Box>
                    <Typography variant="h4" sx={{
                        fontWeight: 700,
                        color: '#1e293b',
                        fontFamily: '"Montserrat", sans-serif',
                        mb: 1
                    }}>
                        Bonjour, {user?.name || ''} 👋
                    </Typography>
                    <Typography variant="body1" sx={{
                        color: '#64748b',
                        fontFamily: '"Montserrat", sans-serif',
                        fontSize: '1.1rem'
                    }}>
                        Voici un aperçu de votre flotte et de vos performances
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                    {/* <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Période</InputLabel>
                        <Select
                            value={dateRange}
                            label="Période"
                            onChange={(e) => setDateRange(e.target.value)}
                        >
                            <MenuItem value="7">7 jours</MenuItem>
                            <MenuItem value="30">30 jours</MenuItem>
                            <MenuItem value="90">90 jours</MenuItem>
                            <MenuItem value="365">1 an</MenuItem>
                        </Select>
                    </FormControl> */}
                    <Button
                        variant="outlined"
                        startIcon={<RefreshIcon />}
                        onClick={refreshData}
                        disabled={loading}
                        sx={{
                            borderRadius: 2,
                            borderColor: '#6366f1',
                            color: '#6366f1',
                            '&:hover': {
                                borderColor: '#4f46e5',
                                backgroundColor: 'rgba(99, 102, 241, 0.04)'
                            }
                        }}
                    >
                        Actualiser
                    </Button>
                </Box>
            </Box>

            {/* Error Message */}
            {error && (
                <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }} onClose={() => setError(null)}>
                    <Typography sx={{ fontFamily: '"Montserrat", sans-serif' }}>{error}</Typography>
                </Alert>
            )}

            {/* Loading Indicator */}
            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                    <CircularProgress sx={{ color: '#6366f1' }} />
                </Box>
            )}

            {/* Dashboard Tabs */}
            <Paper
                elevation={0}
                sx={{
                    mb: 3,
                    borderRadius: "20px",
                    overflow: "hidden",
                    border: "1px solid #e2e8f0",
                    background: "#ffffff",
                    boxShadow: "0 8px 30px rgba(15, 23, 42, 0.06)",
                }}
            >
                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    sx={{
                        minHeight: '100%',
                        px: 1,
                        backgroundColor: "#ffffff",

                        "& .MuiTabs-flexContainer": {
                            gap: 1,
                            padding: "8px",
                        },

                            "& .MuiTabs-indicator": {
                                display: "none",
                            },
                    }}
                >
                    <Tab
                        icon={<DashboardIcon />}
                        iconPosition="start"
                        label="Vue d'ensemble"
                        sx={{
                            minHeight: 56,
                            borderRadius: "14px",
                            textTransform: "none",
                            fontSize: "15px",
                            fontWeight: 600,
                            fontFamily: '"Montserrat", sans-serif',
                            color: "#475569",
                            transition: "all 0.3s ease",

                            "&:hover": {
                                backgroundColor: "#f8fafc",
                                color: "#4f46e5",
                            },

                            "&.Mui-selected": {
                                color: "#4f46e5",
                                backgroundColor: "#f8faff",
                            },
                        }}
                    />

                    <Tab
                        icon={<AnalyticsIcon />}
                        iconPosition="start"
                        label="Analytics"
                        sx={{
                            minHeight: 56,
                            borderRadius: "14px",
                            textTransform: "none",
                            fontSize: "15px",
                            fontWeight: 600,
                            fontFamily: '"Montserrat", sans-serif',
                            color: "#475569",
                            transition: "all 0.3s ease",

                            "&:hover": {
                                backgroundColor: "#f8fafc",
                                color: "#4f46e5",
                            },

                            "&.Mui-selected": {
                                color: "#4f46e5",
                                backgroundColor: "#f8faff",
                            },
                        }}
                    />

                    <Tab
                        icon={<CompareArrowsIcon />}
                        iconPosition="start"
                        label="Opérations"
                        sx={{
                            minHeight: 56,
                            borderRadius: "14px",
                            textTransform: "none",
                            fontSize: "15px",
                            fontWeight: 600,
                            fontFamily: '"Montserrat", sans-serif',
                            color: "#475569",
                            transition: "all 0.3s ease",

                            "&:hover": {
                                backgroundColor: "#f8fafc",
                                color: "#4f46e5",
                            },

                            "&.Mui-selected": {
                                color: "#4f46e5",
                                backgroundColor: "#f8faff",
                            },
                        }}
                    />
                </Tabs>
            </Paper>

            {/* Overview Tab Content */}
            {activeTab === 0 && !loading && (
                <>
                    {/* KPI Cards */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Voyages Totaux"
                                value={dashboardData.summary?.totalVoyages || 0}
                                icon={<LocalShippingIcon sx={{ color: '#6366f1', fontSize: 28 }} />}
                                color="#6366f1"
                                bgColor="rgba(99, 102, 241, 0.1)"
                                trend={dashboardData.summary?.monthlyStats?.voyages || 0}
                                subtitle="Ce mois"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Voyages Actifs"
                                value={dashboardData.summary?.activeVoyages || 0}
                                icon={<TimelineIcon sx={{ color: '#10b981', fontSize: 28 }} />}
                                color="#10b981"
                                bgColor="rgba(16, 185, 129, 0.1)"
                                trend={8}
                                subtitle="En cours"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Revenus Totaux"
                                value={formatCurrency(dashboardData.summary?.totalRevenue || 0)}
                                icon={<PaidIcon sx={{ color: '#f59e0b', fontSize: 28 }} />}
                                color="#f59e0b"
                                bgColor="rgba(245, 158, 11, 0.1)"
                                trend={15}
                                subtitle="Cette année"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Voyages Terminés"
                                value={dashboardData.summary?.completedVoyages || 0}
                                icon={<CheckCircleIcon sx={{ color: '#ec4899', fontSize: 28 }} />}
                                color="#ec4899"
                                bgColor="rgba(236, 72, 153, 0.1)"
                                trend={-3}
                                subtitle="Ce mois"
                            />
                        </Grid>
                    </Grid>

                    {/* Charts Row */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} lg={8}>
                            <ChartCard
                                title="Tendances des Revenus"
                                icon={<AssessmentIcon sx={{ color: '#6366f1' }} />}
                                subtitle={`Évolution des revenus - ${new Date().toLocaleString('fr-FR', { month: 'long' })}`}
                            >
                                <ResponsiveContainer width="100%" height={300}>
                                    <AreaChart data={dashboardData.monthlyRevenue || []}>
                                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                        <XAxis dataKey="month" stroke="#64748b" />
                                        <YAxis stroke="#64748b" />
                                        <RechartsTooltip
                                            contentStyle={{
                                                backgroundColor: '#fff',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                border: '1px solid #e2e8f0',
                                                fontFamily: '"Montserrat", sans-serif'
                                            }}
                                        />
                                        <Area
                                            type="monotone"
                                            dataKey="revenue"
                                            stroke="#6366f1"
                                            fill="rgba(99, 102, 241, 0.1)"
                                            strokeWidth={2}
                                        />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </ChartCard>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <ChartCard
                                title="État de la Flotte"
                                icon={<DirectionsCarIcon sx={{ color: '#10b981' }} />}
                                subtitle="Répartition par statut"
                            >
                                <ResponsiveContainer width="100%" height={300}>
                                    <PieChart>
                                        <Pie
                                            data={dashboardData.vehicleStatus}
                                            cx="50%"
                                            cy="50%"
                                            labelLine={false}
                                            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                            outerRadius={80}
                                            fill="#8884d8"
                                            dataKey="value"
                                        >
                                            {dashboardData.vehicleStatus?.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <RechartsTooltip
                                            contentStyle={{
                                                backgroundColor: '#fff',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                border: '1px solid #e2e8f0',
                                                fontFamily: '"Montserrat", sans-serif'
                                            }}
                                        />
                                    </PieChart>
                                </ResponsiveContainer>
                            </ChartCard>
                        </Grid>
                    </Grid>

                    {/* Alerts and Activity Row */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <ChartCard
                                title="Alertes Importantes"
                                icon={<NotificationsIcon sx={{ color: '#ef4444' }} />}
                            >
                                <Grid container spacing={2}>
                                    {dashboardData.alerts?.map((alert, index) => (
                                        <Grid item xs={12} key={index}>
                                            <AlertCard
                                                title={alert.title}
                                                message={alert.message}
                                                type={alert.type}
                                                count={alert.count}
                                                icon={alert.type === 'warning' ?
                                                    <WarningIcon sx={{ color: 'white' }} /> :
                                                    <SecurityIcon sx={{ color: 'white' }} />
                                                }
                                            />
                                        </Grid>
                                    ))}
                                </Grid>
                            </ChartCard>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <ChartCard
                                title="Activité Récente"
                                icon={<TimelineIcon sx={{ color: '#6366f1' }} />}
                                subtitle="Dernières actions sur la plateforme"
                            >
                                <ActivityFeed activities={dashboardData.recentActivities || []} />
                            </ChartCard>
                        </Grid>
                    </Grid>
                </>
            )}

            {/* Analytics Tab Content */}
            {activeTab === 1 && !loading && (
                <>
                    {/* Analytics KPI Cards */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Taux de remplissage"
                                value={`${dashboardData.analytics?.fillRate || 0}%`}
                                icon={<LocalShippingIcon sx={{ color: '#6366f1', fontSize: 28 }} />}
                                color="#6366f1"
                                bgColor="rgba(99, 102, 241, 0.1)"
                                trend={5}
                                subtitle="Ce mois"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Consommation moyenne"
                                value={`${dashboardData.analytics?.avgFuelConsumption || 0}L/100km`}
                                icon={<LocalGasStationIcon sx={{ color: '#10b981', fontSize: 28 }} />}
                                color="#10b981"
                                bgColor="rgba(16, 185, 129, 0.1)"
                                trend={-2}
                                subtitle="Ce mois"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Distance moyenne"
                                value={`${dashboardData.analytics?.avgDistance || 0} km`}
                                icon={<RouteIcon sx={{ color: '#f59e0b', fontSize: 28 }} />}
                                color="#f59e0b"
                                bgColor="rgba(245, 158, 11, 0.1)"
                                trend={8}
                                subtitle="Par voyage"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Durée moyenne"
                                value={`${dashboardData.analytics?.avgDuration || 0} h`}
                                icon={<SpeedIcon sx={{ color: '#ec4899', fontSize: 28 }} />}
                                color="#ec4899"
                                bgColor="rgba(236, 72, 153, 0.1)"
                                trend={-1}
                                subtitle="Par voyage"
                            />
                        </Grid>
                    </Grid>

                    {/* Analytics Charts Row 1 */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} lg={6}>
                            <ChartCard
                                title="Revenus par Région"
                                icon={<MapIcon sx={{ color: '#6366f1' }} />}
                                subtitle="Distribution géographique des revenus"
                            >
                                <ResponsiveContainer width="100%" height={300}>
                                    <BarChart data={dashboardData.revenueByRegion}>
                                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                        <XAxis dataKey="name" stroke="#64748b" />
                                        <YAxis stroke="#64748b" />
                                        <RechartsTooltip
                                            contentStyle={{
                                                backgroundColor: '#fff',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                border: '1px solid #e2e8f0',
                                                fontFamily: '"Montserrat", sans-serif'
                                            }}
                                        />
                                        <Bar dataKey="value" fill="#6366f1" radius={[8, 8, 0, 0]} />
                                    </BarChart>
                                </ResponsiveContainer>
                            </ChartCard>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <ChartCard
                                title="Consommation de Carburant"
                                icon={<LocalGasStationIcon sx={{ color: '#10b981' }} />}
                                subtitle="Consommation et coûts mensuels"
                            >
                                <ResponsiveContainer width="100%" height={300}>
                                    <LineChart data={dashboardData.fuelConsumption}>
                                        <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
                                        <XAxis dataKey="month" stroke="#64748b" />
                                        <YAxis stroke="#64748b" />
                                        <RechartsTooltip
                                            contentStyle={{
                                                backgroundColor: '#fff',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                border: '1px solid #e2e8f0',
                                                fontFamily: '"Montserrat", sans-serif'
                                            }}
                                        />
                                        <Legend />
                                        <Line
                                            type="monotone"
                                            dataKey="consumption"
                                            stroke="#10b981"
                                            strokeWidth={2}
                                            name="Consommation (L)"
                                        />
                                        <Line
                                            type="monotone"
                                            dataKey="cost"
                                            stroke="#f59e0b"
                                            strokeWidth={2}
                                            name="Coût (MAD)"
                                        />
                                    </LineChart>
                                </ResponsiveContainer>
                            </ChartCard>
                        </Grid>
                    </Grid>

                    {/* Analytics Charts Row 2 */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} lg={6}>
                            <ChartCard
                                title="Performance des Chauffeurs"
                                icon={<PersonIcon sx={{ color: '#ec4899' }} />}
                                subtitle="Évaluation sur plusieurs critères"
                            >
                                <ResponsiveContainer width="100%" height={300}>
                                    <RadarChart data={dashboardData.driverPerformance}>
                                        <PolarGrid stroke="#e2e8f0" />
                                        <PolarAngleAxis dataKey="subject" stroke="#64748b" />
                                        <PolarRadiusAxis angle={90} domain={[0, 100]} stroke="#64748b" />
                                        <Radar
                                            name="Performance"
                                            dataKey="value"
                                            stroke="#ec4899"
                                            fill="#ec4899"
                                            fillOpacity={0.6}
                                        />
                                        <RechartsTooltip
                                            contentStyle={{
                                                backgroundColor: '#fff',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                border: '1px solid #e2e8f0',
                                                fontFamily: '"Montserrat", sans-serif'
                                            }}
                                        />
                                    </RadarChart>
                                </ResponsiveContainer>
                            </ChartCard>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <ChartCard
                                title="Distribution des Clients"
                                icon={<BusinessIcon sx={{ color: '#8b5cf6' }} />}
                                subtitle="Répartition des revenus par client"
                            >
                                <ResponsiveContainer width="100%" height={300}>
                                    <PieChart>
                                        <Pie
                                            data={dashboardData.clientDistribution}
                                            cx="50%"
                                            cy="50%"
                                            labelLine={false}
                                            label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                                            outerRadius={80}
                                            fill="#8884d8"
                                            dataKey="value"
                                        >
                                            {dashboardData.clientDistribution?.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <RechartsTooltip
                                            contentStyle={{
                                                backgroundColor: '#fff',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                                                border: '1px solid #e2e8f0',
                                                fontFamily: '"Montserrat", sans-serif'
                                            }}
                                        />
                                    </PieChart>
                                </ResponsiveContainer>
                            </ChartCard>
                        </Grid>
                    </Grid>

                    {/* Top Routes Table */}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <ChartCard
                                title="Routes les Plus Populaires"
                                icon={<RouteIcon sx={{ color: '#f59e0b' }} />}
                                subtitle="Basé sur le nombre de voyages"
                                action={
                                    <Button
                                        variant="outlined"
                                        startIcon={<DownloadIcon />}
                                        size="small"
                                        sx={{ borderRadius: 2, borderColor: '#e2e8f0', color: '#64748b' }}
                                    >
                                        Exporter
                                    </Button>
                                }
                            >
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Route</TableCell>
                                                <TableCell align="right">Nombre de voyages</TableCell>
                                                <TableCell align="right">Revenus totaux</TableCell>
                                                <TableCell align="right">Distance moyenne</TableCell>
                                                <TableCell align="right">Durée moyenne</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dashboardData.topRoutes?.map((route, index) => (
                                                <TableRow key={index}>
                                                    <TableCell component="th" scope="row">
                                                        {route.from} - {route.to}
                                                    </TableCell>
                                                    <TableCell align="right">{route.count}</TableCell>
                                                    <TableCell align="right">{formatCurrency(route.revenue)}</TableCell>
                                                    <TableCell align="right">{formatDistance(route.avgDistance)}</TableCell>
                                                    <TableCell align="right">{formatDuration(route.avgDuration)}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ChartCard>
                        </Grid>
                    </Grid>
                </>
            )}

            {/* Operations Tab Content */}
            {activeTab === 2 && !loading && (
                <>
                    {/* Operations KPI Cards */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Voyages en cours"
                                value={dashboardData.summary?.activeVoyages || 0}
                                icon={<LocalShippingIcon sx={{ color: '#6366f1', fontSize: 28 }} />}
                                color="#6366f1"
                                bgColor="rgba(99, 102, 241, 0.1)"
                                subtitle="Actifs aujourd'hui"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Véhicules disponibles"
                                value={dashboardData.vehicleStatus?.find(v => v.name === 'Disponible')?.value || 0}
                                icon={<DirectionsCarIcon sx={{ color: '#10b981', fontSize: 28 }} />}
                                color="#10b981"
                                bgColor="rgba(16, 185, 129, 0.1)"
                                subtitle="Prêts pour utilisation"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Chauffeurs disponibles"
                                value="8"
                                icon={<PersonIcon sx={{ color: '#f59e0b', fontSize: 28 }} />}
                                color="#f59e0b"
                                bgColor="rgba(245, 158, 11, 0.1)"
                                subtitle="Non assignés"
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={3}>
                            <KPICard
                                title="Tâches en attente"
                                value={dashboardData.upcomingMaintenance?.length || 0}
                                icon={<AssignmentIcon sx={{ color: '#ef4444', fontSize: 28 }} />}
                                color="#ef4444"
                                bgColor="rgba(239, 68, 68, 0.1)"
                                subtitle="À traiter"
                            />
                        </Grid>
                    </Grid>

                    {/* Active Trips and Tasks */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12} lg={8}>
                            <OperationsTable
                                data={dashboardData.activeTrips || []}
                                columns={tripColumns}
                                title="Voyages Actifs"
                                icon={<LocalShippingIcon sx={{ color: '#6366f1' }} />}
                                actions={tripActions}
                                onActionClick={handleTripAction}
                                loading={loading}
                            />
                        </Grid>
                        <Grid item xs={12} lg={4}>
                            <TaskList
                                tasks={dashboardData.upcomingMaintenance || []}
                                title="Tâches à Venir"
                                icon={<AssignmentIcon sx={{ color: '#f59e0b' }} />}
                                onTaskClick={(task) => navigate(`/tasks/${task.id}`)}
                            />
                        </Grid>
                    </Grid>

                    {/* Quick Actions */}
                    {/* <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12}>
                            <ChartCard
                                title="Actions Rapides"
                                icon={<SpeedIcon sx={{ color: '#6366f1' }} />}
                                subtitle="Opérations courantes"
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            startIcon={<AddCircleOutlineIcon />}
                                            onClick={() => setNewTripDialogOpen(true)}
                                            sx={{
                                                p: 2,
                                                height: '100%',
                                                borderRadius: 2,
                                                borderColor: '#6366f1',
                                                color: '#6366f1',
                                                flexDirection: 'column',
                                                '&:hover': {
                                                    borderColor: '#4f46e5',
                                                    backgroundColor: 'rgba(99, 102, 241, 0.04)'
                                                }
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
                                                Nouveau Voyage
                                            </Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            startIcon={<BuildIcon />}
                                            onClick={() => setMaintenanceDialogOpen(true)}
                                            sx={{
                                                p: 2,
                                                height: '100%',
                                                borderRadius: 2,
                                                borderColor: '#10b981',
                                                color: '#10b981',
                                                flexDirection: 'column',
                                                '&:hover': {
                                                    borderColor: '#059669',
                                                    backgroundColor: 'rgba(16, 185, 129, 0.04)'
                                                }
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
                                                Planifier Maintenance
                                            </Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            startIcon={<ReceiptIcon />}
                                            onClick={() => navigate('/invoices/new')}
                                            sx={{
                                                p: 2,
                                                height: '100%',
                                                borderRadius: 2,
                                                borderColor: '#f59e0b',
                                                color: '#f59e0b',
                                                flexDirection: 'column',
                                                '&:hover': {
                                                    borderColor: '#d97706',
                                                    backgroundColor: 'rgba(245, 158, 11, 0.04)'
                                                }
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
                                                Générer Facture
                                            </Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            startIcon={<DescriptionIcon />}
                                            onClick={() => setDocumentDialogOpen(true)}
                                            sx={{
                                                p: 2,
                                                height: '100%',
                                                borderRadius: 2,
                                                borderColor: '#ec4899',
                                                color: '#ec4899',
                                                flexDirection: 'column',
                                                '&:hover': {
                                                    borderColor: '#db2777',
                                                    backgroundColor: 'rgba(236, 72, 153, 0.04)'
                                                }
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ mt: 1, fontWeight: 600 }}>
                                                Nouveau Document
                                            </Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            </ChartCard>
                        </Grid>
                    </Grid> */}

                    {/* Recent Documents */}
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <ChartCard
                                title="Documents Récents"
                                icon={<DescriptionIcon sx={{ color: '#8b5cf6' }} />}
                                action={
                                    <Button

                                        variant="outlined"
                                        startIcon={<AddIcon />}
                                        size="small"
                                        onClick={() => setDocumentDialogOpen(true)}
                                        sx={{ borderRadius: 2, borderColor: '#e2e8f0', color: '#64748b' }}
                                    >
                                        Ajouter
                                    </Button>
                                }
                            >
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>Nom du document</TableCell>
                                                <TableCell>Type</TableCell>
                                                <TableCell>Entité associée</TableCell>
                                                <TableCell>Date d'expiration</TableCell>
                                                <TableCell>Statut</TableCell>
                                                <TableCell align="center">Actions</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {dashboardData.recentDocuments?.map((doc, index) => (
                                                <TableRow key={index}>
                                                    <TableCell>{doc.title}</TableCell>
                                                    <TableCell>{doc.type}</TableCell>
                                                    <TableCell>{doc.entityName}</TableCell>
                                                    <TableCell>{formatDate(doc.expirationDate)}</TableCell>
                                                    <TableCell>
                                                        <Chip
                                                            label={doc.status}
                                                            size="small"
                                                            color={doc.status === 'Valide' ? 'success' : doc.status === 'Expiré' ? 'error' : 'warning'}
                                                        />
                                                    </TableCell>
                                                    <TableCell align="center">
                                                        <Tooltip title="Voir">
                                                            <IconButton size="small" onClick={() => window.open(doc.url, '_blank')}>
                                                                <VisibilityIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                        <Tooltip title="Télécharger">
                                                            <IconButton size="small" onClick={() => window.open(doc.downloadUrl, '_blank')}>
                                                                <DownloadIcon fontSize="small" />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </ChartCard>
                        </Grid>
                    </Grid>
                </>
            )}

            {/* New Trip Dialog */}
            {/* <OperationDialog
                open={newTripDialogOpen}
                handleClose={() => setNewTripDialogOpen(false)}
                title="Créer un Nouveau Voyage"
                onConfirm={handleCreateTrip}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Client</InputLabel>
                            <Select
                                value={newTripForm.clientId}
                                label="Client"
                                onChange={(e) => setNewTripForm({ ...newTripForm, clientId: e.target.value })}
                            >
                                <MenuItem value="">Sélectionner un client</MenuItem>
                                
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Véhicule</InputLabel>
                            <Select
                                value={newTripForm.vehicleId}
                                label="Véhicule"
                                onChange={(e) => setNewTripForm({ ...newTripForm, vehicleId: e.target.value })}
                            >
                                <MenuItem value="">Sélectionner un véhicule</MenuItem>
                               
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Chauffeur</InputLabel>
                            <Select
                                value={newTripForm.driverId}
                                label="Chauffeur"
                                onChange={(e) => setNewTripForm({ ...newTripForm, driverId: e.target.value })}
                            >
                                <MenuItem value="">Sélectionner un chauffeur</MenuItem>
                               
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Type de cargaison"
                            value={newTripForm.cargoType}
                            onChange={(e) => setNewTripForm({ ...newTripForm, cargoType: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Lieu de départ"
                            value={newTripForm.departureLocation}
                            onChange={(e) => setNewTripForm({ ...newTripForm, departureLocation: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            label="Destination"
                            value={newTripForm.destinationLocation}
                            onChange={(e) => setNewTripForm({ ...newTripForm, destinationLocation: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label="Date de départ"
                            value={newTripForm.departureDate}
                            onChange={(e) => setNewTripForm({ ...newTripForm, departureDate: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label="Date d'arrivée prévue"
                            value={newTripForm.expectedArrivalDate}
                            onChange={(e) => setNewTripForm({ ...newTripForm, expectedArrivalDate: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Notes"
                            value={newTripForm.notes}
                            onChange={(e) => setNewTripForm({ ...newTripForm, notes: e.target.value })}
                        />
                    </Grid>
                </Grid>
            </OperationDialog> */}

            {/* Maintenance Dialog */}
            <OperationDialog
                open={maintenanceDialogOpen}
                handleClose={() => setMaintenanceDialogOpen(false)}
                title="Planifier une Maintenance"
                onConfirm={handleScheduleMaintenance}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Véhicule</InputLabel>
                            <Select
                                value={maintenanceForm.vehicleId}
                                label="Véhicule"
                                onChange={(e) => setMaintenanceForm({ ...maintenanceForm, vehicleId: e.target.value })}
                            >
                                <MenuItem value="">Sélectionner un véhicule</MenuItem>
                                {/* Add vehicle options from API */}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Type de maintenance</InputLabel>
                            <Select
                                value={maintenanceForm.maintenanceType}
                                label="Type de maintenance"
                                onChange={(e) => setMaintenanceForm({ ...maintenanceForm, maintenanceType: e.target.value })}
                            >
                                <MenuItem value="routine">Routine</MenuItem>
                                <MenuItem value="repair">Réparation</MenuItem>
                                <MenuItem value="inspection">Inspection</MenuItem>
                                <MenuItem value="emergency">Urgence</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="date"
                            label="Date planifiée"
                            value={maintenanceForm.scheduledDate}
                            onChange={(e) => setMaintenanceForm({ ...maintenanceForm, scheduledDate: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            type="number"
                            label="Coût estimé (MAD)"
                            value={maintenanceForm.estimatedCost}
                            onChange={(e) => setMaintenanceForm({ ...maintenanceForm, estimatedCost: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={3}
                            label="Description"
                            value={maintenanceForm.description}
                            onChange={(e) => setMaintenanceForm({ ...maintenanceForm, description: e.target.value })}
                        />
                    </Grid>
                </Grid>
            </OperationDialog>

            {/* Document Dialog */}
            <OperationDialog
                open={documentDialogOpen}
                handleClose={() => setDocumentDialogOpen(false)}
                title="Ajouter un Document"
                onConfirm={handleUploadDocument}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Titre du document"
                            value={documentForm.title}
                            onChange={(e) => setDocumentForm({ ...documentForm, title: e.target.value })}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Type de document</InputLabel>
                            <Select
                                value={documentForm.type}
                                label="Type de document"
                                onChange={(e) => setDocumentForm({ ...documentForm, type: e.target.value })}
                            >
                                <MenuItem value="insurance">Assurance</MenuItem>
                                <MenuItem value="registration">Carte grise</MenuItem>
                                <MenuItem value="license">Permis de conduire</MenuItem>
                                <MenuItem value="contract">Contrat</MenuItem>
                                <MenuItem value="other">Autre</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                            <InputLabel>Type d'entité</InputLabel>
                            <Select
                                value={documentForm.entityType}
                                label="Type d'entité"
                                onChange={(e) => setDocumentForm({ ...documentForm, entityType: e.target.value })}
                            >
                                <MenuItem value="vehicle">Véhicule</MenuItem>
                                <MenuItem value="driver">Chauffeur</MenuItem>
                                <MenuItem value="client">Client</MenuItem>
                                <MenuItem value="company">Entreprise</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            type="file"
                            label="Fichier"
                            onChange={(e) => setDocumentForm({ ...documentForm, file: e.target.files[0] })}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            type="date"
                            label="Date d'expiration"
                            value={documentForm.expirationDate}
                            onChange={(e) => setDocumentForm({ ...documentForm, expirationDate: e.target.value })}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </Grid>
            </OperationDialog>

            {/* Floating Action Button */}
            {/* <Fab
                color="primary"
                aria-label="add"
                onClick={() => setNewTripDialogOpen(true)}
                sx={{
                    position: 'fixed',
                    bottom: 30,
                    right: 30,
                    bgcolor: '#6366f1',
                    '&:hover': {
                        bgcolor: '#4f46e5'
                    }
                }}
            >
                <AddIcon />
            </Fab> */}
        </Box>
    );
};

export default Dashboard;